import type { PropsWithChildren } from 'react'

import { ObjectSelectionProvider } from './ObjectSelectionContext'
import { NoteEditorProvider } from './NoteEditorContext'
import { AgentCreatedProvider } from './AgentCreatedContext'
import { ChatDockProvider } from './ChatDockContext'
import { BriefDockProvider } from './BriefDockContext'
import { ModulePaneProvider } from './ModulePaneContext'
import { ChatAgentScopeProvider } from './ChatAgentScopeContext'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <AgentCreatedProvider>
      <ObjectSelectionProvider>
        <NoteEditorProvider>
          <ChatDockProvider>
            <BriefDockProvider>
              <ModulePaneProvider>
                <ChatAgentScopeProvider>
                  {children}
                </ChatAgentScopeProvider>
              </ModulePaneProvider>
            </BriefDockProvider>
          </ChatDockProvider>
        </NoteEditorProvider>
      </ObjectSelectionProvider>
    </AgentCreatedProvider>
  )
}
